import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
const linkBlockTextGroup = ({ theme }) => css `
	display: flex;
	gap: ${pxToRem(theme.spacing['50'])};
	flex-direction: column;
	overflow: hidden;
`;
export const StyledLinkBlockTextGroup = styled.div `
	${linkBlockTextGroup}
`;
